import { FC } from "react";

type Props = {};

export const ScreenLoading: FC<Props> = () => {
  return (
    <div className="w-dvw h-dvh flex flex-col items-center justify-center bg-gray-300 text-white">
      <div className="flex space-x-3 mb-6">
        <div
          className="w-5 h-5 bg-gray-700 rounded-full animate-bounce"
          style={{ animationDelay: "0ms" }}
        ></div>
        <div
          className="w-5 h-5 bg-gray-700 rounded-full animate-bounce"
          style={{ animationDelay: "150ms" }}
        ></div>
        <div
          className="w-5 h-5 bg-gray-700 rounded-full animate-bounce"
          style={{ animationDelay: "300ms" }}
        ></div>
        <div
          className="w-5 h-5 bg-gray-700 rounded-full animate-bounce"
          style={{ animationDelay: "450ms" }}
        ></div>
      </div>
    </div>
  );
};
